import { ICoverage, IQuote, InsuranceQuoteType, QuoteTypeCodes } from '@/interfaces';
import { toSafeDisplayPostcode } from '../convert';

export enum HomeQuoteStepIds {
  policyStartDate = 0,
  startYourQuote = 100,
  buildingDetails = 200,
  portableItems = 300,
  homeItems = 400,
  generalContents = 500,
  personalDetails = 600,
  yourQuote = 700,
}

const usesGoToFunction = ['personalDetails'];

export const formatHomeLocationDetails = (quote: IQuote) => {
  return `${quote.homeAndContentsQuote?.homeLocationDetails?.unitNumber?.value ?? ''} ${quote.homeAndContentsQuote?.homeLocationDetails?.buildingLevel?.value ?? ''} ${quote.homeAndContentsQuote?.homeLocationDetails?.streetNumber?.value} 
      ${quote.homeAndContentsQuote?.homeLocationDetails?.streetName?.value}, 
      ${quote.homeAndContentsQuote?.homeLocationDetails?.suburb?.value} 
      ${quote.homeAndContentsQuote?.homeLocationDetails?.state?.value}
      ${quote.homeAndContentsQuote?.homeLocationDetails?.postCode?.value}`;
};

export const getEditGoToStep = (editStep: string) => {
  const useGoToFunction = usesGoToFunction.findIndex((x) => x == editStep) > -1;
  if (!useGoToFunction) return undefined;
  const foundStep = Object.keys(HomeQuoteStepIds)[Object.values(HomeQuoteStepIds).indexOf(editStep)];

  switch (foundStep) {
    case HomeQuoteStepIds.personalDetails.toString():
      return 0;
  }
  return undefined;
};

export const getInsuranceTypeDisplayNameUsingInsuranceQuoteType = (dictionary: any, quoteType: InsuranceQuoteType) => {
  switch (quoteType) {
    case InsuranceQuoteType.MotorComprehensive:
      return dictionary.IT_Motorcycle;
    case InsuranceQuoteType.Home:
      return dictionary.IT_HH;
    case InsuranceQuoteType.Contents:
      return dictionary.IT_HC;
    case InsuranceQuoteType.HomeAndContents:
      return dictionary.IT_HHCOMB;
    case InsuranceQuoteType.MotorFireTheftAndThirdPartyLiability:
      return dictionary.MotorFireTheftAndThirdPartyLiability;
    case InsuranceQuoteType.MotorThirdPartyLiability:
      return dictionary.MotorThirdPartyLiability;
    case InsuranceQuoteType.PetComp:
      return dictionary.IT_PET;
  }
};

export const getInsuranceTypeDisplayName = (dictionary: any, quoteType: string) => {
  switch (quoteType.toString()) {
    case QuoteTypeCodes[InsuranceQuoteType.Contents]:
      return dictionary.IT_HC;
    case QuoteTypeCodes[InsuranceQuoteType.Home]:
      return dictionary.IT_HH;
    case QuoteTypeCodes[InsuranceQuoteType.HomeAndContents]:
      return dictionary.IT_HHCOMB;
    case QuoteTypeCodes[InsuranceQuoteType.MotorComprehensive]:
    case QuoteTypeCodes[InsuranceQuoteType.MotorComprehensiveOther]:
      return dictionary.IT_MC;
    case QuoteTypeCodes[InsuranceQuoteType.MotorFireTheftAndThirdPartyLiability]:
    case QuoteTypeCodes[InsuranceQuoteType.MotorFireTheftAndThirdPartyLiabilityOther]:
      return dictionary.IT_MF;
    case QuoteTypeCodes[InsuranceQuoteType.MotorThirdPartyLiability]:
    case QuoteTypeCodes[InsuranceQuoteType.MotorThirdPartyLiabilityOther]:
      return dictionary.IT_MT;
    case QuoteTypeCodes[InsuranceQuoteType.PetComp]:
      return dictionary.IT_PET;
    case QuoteTypeCodes[InsuranceQuoteType.Caravan]:
      return dictionary.IT_Caravan;
    case QuoteTypeCodes[InsuranceQuoteType.Motorcycle]:
      return dictionary.IT_Motorcycle;
    case QuoteTypeCodes[InsuranceQuoteType.BoatComprehensive]:
      return dictionary.IT_BC;
    case QuoteTypeCodes[InsuranceQuoteType.BoatThirdParty]:
      return dictionary.IT_BT;
  }

  return '';
};

export const getInsuranceQuoteTypeDisplayName = (dictionary: any, quoteType: InsuranceQuoteType) => {
  switch (quoteType) {
    case InsuranceQuoteType.Contents:
      return dictionary.IT_HC;
    case InsuranceQuoteType.Home:
      return dictionary.IT_HH;
    case InsuranceQuoteType.HomeAndContents:
      return dictionary.IT_HHCOMB;
    case InsuranceQuoteType.MotorComprehensive:
      return dictionary.IT_MC;
    case InsuranceQuoteType.MotorFireTheftAndThirdPartyLiability:
      return dictionary.IT_MF;
    case InsuranceQuoteType.MotorThirdPartyLiability:
      return dictionary.IT_MT;
    case InsuranceQuoteType.PetComp:
      return dictionary.IT_PET;
    case InsuranceQuoteType.Motorcycle:
      return dictionary.IT_Motorcycle;
    case InsuranceQuoteType.Caravan:
      return dictionary.IT_Caravan;
    case InsuranceQuoteType.BoatComprehensive:
      return dictionary.IT_BC;
    case InsuranceQuoteType.BoatThirdParty:
      return dictionary.IT_BT;
  }

  return '';
};

export const getPolicyDescription = (dictionary: any, coverages: ICoverage[]) => {
  if (coverages.length > 1) {
    let isHouseHoldPolicyType = false;

    coverages.forEach((c) => {
      if (
        c.coverageCode === QuoteTypeCodes[InsuranceQuoteType.Contents] ||
        c.coverageCode === QuoteTypeCodes[InsuranceQuoteType.Home] ||
        c.coverageCode === QuoteTypeCodes[InsuranceQuoteType.HomeAndContents]
      ) {
        isHouseHoldPolicyType = true;
        return;
      }
    });

    if (isHouseHoldPolicyType) {
      return dictionary.IT_Combined_Household;
    }

    return dictionary.IT_Combined;
  }

  return getInsuranceTypeDisplayName(dictionary, coverages[0].coverageCode);
};
